import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { KngCardListFactory } from './kng-card-list.factory';
import { KngCardListState } from './definitions';
import * as _ from 'lodash';

@Injectable({
	providedIn: 'root'
})
export class KngCardListService 
{
	private state$: BehaviorSubject<KngCardListState> =
		new BehaviorSubject<KngCardListState>(KngCardListFactory.build());
	get state(): KngCardListState 
	{
		return this.state$.value;
	}
	get stateChanged(): Observable<KngCardListState> 
	{
		return this.state$.asObservable();
	}

	public updateState(value: KngCardListState): void 
	{
		this.state$.next(value);
	}
}

@Injectable({
	providedIn: 'root'
})
export class PagerService 
{
	getPager(totalItems: number, currentPage: number,  pageSize: number) 
	{
		const totalPages = Math.ceil(totalItems / pageSize);
		let startPage: number, endPage: number;
		if (totalPages <= 5) 
		{
			startPage = 1;
			endPage = totalPages > 0 ? totalPages : 1;
		}
		else 
		{
			const startEndObj=this.getCurrentPage( currentPage, totalPages);
			startPage=startEndObj.startPage;
			endPage=startEndObj.endPage;
			
		}

		const startIndex = (currentPage - 1) * pageSize;
		const endIndex = Math.min(
			startIndex + pageSize - 1,
			totalItems > 1 ? totalItems - 1 : 0
		);
      
		
		const pages = _.range(startPage, endPage + 1);
		return {
			totalPages: totalPages,
			currentPage: currentPage,
			endIndex: endIndex,
			endPage: endPage,
			pages: pages,
			pageSize: pageSize,
			startIndex: startIndex,
			startPage: startPage,
			totalItems: totalItems
		};
	}

	getCurrentPage(currentPage:number, totalPages:number )
	{
		let startPage: number, endPage: number;
		if (currentPage <= 3) 
		{
			startPage = 1;
			endPage = 5;
		}
		else if (currentPage + 1 >= totalPages) 
		{
			startPage = totalPages - 4;
			endPage = totalPages;
		}
		else 
		{
			startPage = currentPage - 2;
			endPage = currentPage + 2;
		}
		return { startPage: startPage, endPage: endPage };
	}	
	
}
